<template>
  <div :class="isPC ? 'bottom-bar' : 'm-bottom-bar'">
    <div class="bottom-top" v-if='!isPC'>
      <div class="text">
        <div class="child1">全链路餐饮经营服务平台</div>
        <div class="child2">联接多渠道打通多场景，深耕餐饮行业需求</div>
        <div class="child2">提供全链路餐饮经营服务</div>
        <div class="child3" @click="handIsDisplay()">立即咨询</div>
      </div>
      <!-- <img src="@/img/mHome/foot_bg(1).png" alt=""> -->
      <img src="https://zhengxin-1301158478.image.myqcloud.com/image/20211018/9773be5323c44771.png?imageView2/1/"
        alt="">
    </div>
    <div class="bottom-main" :class="isPC ? '' : 'fs20'">
      <div class="main">
        <div class="main-one">
          <img :src="require('../../../img/home/logo_w@2x.png')" alt="" style="width: 148px; height: auto;">
        </div>
        <div class="main-two">
          <div class="main-two-top">
            <div class="main-two-top-item" v-for="item in items" :key="item.id"
              :class="{ active: currentMainPath === item.path }" @click="handleClick(item.path)"
              style="cursor: pointer;">{{ item.name }}</div>
          </div>
          <div class="main-two-bottom">
            <div class="main-two-bottom-item" v-for="item in items" :key="item.id">
              <div v-for="son in item.son" :key="son.id" :class="{ active: currentFullPath === son.path }"
                @click="handleClick(son.path)" style="cursor: pointer;">{{ son.name }}</div>
            </div>
          </div>
        </div>
        <div class="main-three">
          <div class="main-three-item" v-for="(icon,index) in icons" :key="index">
            <div :class="index === 3 ? 'qrcode' : 'active'" v-show="icon.active">
              <div v-show="index === 3" style="height: 140px; width: 140px; overflow: hidden;">
                <img :src="require('../../../img/home/wechat.png')" alt="" style="height: 140px; width: auto;">
              </div>
              <div class="title">{{ icon.title }}</div>
              <div class="content" :style="index === 0 ? 'letter-spacing: 1px' : ''">
                {{ icon.content }}
              </div>
            </div>
            <img :src="icon.url" alt="" @mouseover="hoverIcon(index)" @mouseleave="leaveIcon(index)"
              style="cursor: pointer;">
          </div>
        </div>
      </div>
      <div class="footer">
        <div>火码信息科技有限公司 Copyright © 2020-2021 www.huomakeji.com. All Rights
          Reserved&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/">沪ICP备20008461号-4</a> </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BottomBar',
    methods: {
      // handIsDisplay() {
      //   this.$emit('openDialog', true)
      // },
      hoverIcon(index) {
        this.icons[index].active = true
        this.icons[index].url = require('../../../img/home/' + this.icons[index].name + '_active.png')
      },
      leaveIcon(index) {
        if (this.icons[index].click) {
          return;
        };
        this.icons[index].active = false;
        this.icons[index].url = require('../../../img/home/' + this.icons[index].name + '.png')
      },
      clickIcon(index) {
        this.icons[index].click = true;
        this.icons.forEach((item, i) => {
          if (i !== index) {
            item.active = false;
            item.click = false;
            item.url = require('../../../img/home/' + item.name + '.png')
          }
        })
        this.icons[index].active = true;
      },
      handleClick(path) {
        this.newPath = path
        if (!path) return;
        // 处理锚点跳转
        if (path.includes('#')) {
          const [routePath, hash] = path.split('#');

          // 如果是带路由的锚点（如 'product/#ordering'）
          if (routePath) {
            const navMap = {
              'ordering': 0,
              'manager': 1,
              'boss': 2,
              'cloud-store': 3,
              'cloud-screen': 4,
              'helper': 5,
              'product-service': 0,
              'custom': 1,
            };

            // 构造目标路径
            const targetPath = `/layout/${routePath}`;
            const targetHash = `#${hash}`;

            // 检查当前路径和目标路径是否相同
            if (this.$route.path === targetPath && this.$route.hash === targetHash) {
              // 如果完全相同，只执行滚动
              this.scrollToElement(hash);
              if (this.$route.path === '/layout/product/' || '/layout/development/' && navMap[hash] !== undefined) {
                this.scrollToTop();
              }
              return;
            }

            // 先进行路由跳转
            if (this.$route.path !== targetPath) {
              this.$router.push({
                path: targetPath,
                query: { nav: navMap[hash] },  // 保留nav参数
                hash: targetHash
              }).then(() => {
                this.scrollToElement(hash);
                if (navMap[hash] !== undefined) {
                  this.scrollToTop();
                }
              }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err;
                }
                this.scrollToTop();
              });
            } else {
              // 如果路径相同但hash不同，只更新hash和query
              this.$router.replace({
                query: { nav: navMap[hash] },  // 保留nav参数
                hash: targetHash
              }).then(() => {
                this.scrollToElement(hash);
                if (navMap[hash] !== undefined) {
                  this.scrollToTop();
                }
              }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err;
                }
                this.scrollToTop();
              });
            }
          } else {
            // 如果是首页的锚点（如 '/#product-intro'）
            const targetPath = '/layout/home';
            const targetHash = `#${hash}`;

            if (this.$route.path === targetPath && this.$route.hash == targetHash) {
              // 如果完全相同，只执行滚动
              this.scrollToElement(hash);
              return;
            }

            if (this.$route.path !== targetPath) {
              this.$router.push({
                path: targetPath,
                hash: targetHash
              }).then(() => {
                this.scrollToElement(hash);
              }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err;
                }
                this.scrollToTop();
              });
            } else {
              // 如果已经在首页，只更新hash
              this.$router.replace({
                hash: targetHash
              }).then(() => {
                this.scrollToElement(hash);
              }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err;
                }
                this.scrollToTop();
              });
            }
          }
        } else {
          // 普通路由跳转
          const targetPath = path === '/home' ? '/layout/home' : `/layout${path}`;

          // 如果目标路径与当前路径相同，不执行跳转
          if (this.$route.path === targetPath) {
            this.scrollToTop(true);
            return;
          }

          this.$router.push({
            path: targetPath
          }).then(() => {
            this.scrollToTop(true);
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
            this.scrollToTop(true);
          });
        }
      },
      // 滚动到指定元素位置
      scrollToElement(elementId) {
        this.$nextTick(() => {
          setTimeout(() => {
            const targetElement = document.getElementById(elementId);
            if (targetElement) {
              const appElement = document.getElementById('app') || window;
              if (appElement) {
                const offset = this.newPath == 'home/#five-platforms' ? 
                  targetElement.offsetTop + targetElement.offsetHeight + 80 
                    : this.newPath == 'about/#intro' ? targetElement.offsetTop + targetElement.offsetHeight - 300 
                      : this.newPath == 'certificate/#security' ? targetElement.offsetTop + targetElement.offsetHeight - 50 
                        : targetElement.offsetTop + targetElement.offsetHeight - 150 ;
                appElement.scrollTo({
                  top: offset,
                  behavior: 'smooth'
                });
              }
            }
          }, 300); // 增加延时确保DOM已完全更新
        });
      },
      // 滚动到顶部
      scrollToTop(flag) {
        const appElement = document.getElementById('app');
        if (appElement) {
          if (flag) {
            appElement.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          } else {
            const targetElement = document.getElementsByClassName('content-section')[0];
            if (targetElement) {
              setTimeout(() => {
                appElement.scrollTo({
                  top: targetElement.offsetTop + 550,
                  behavior: 'auto'
                });
              }, 300);
            }
          }
        }
      }
    },
    data() {
      return {
        newPath: '',
        items: [
          {
            name: '首页', son: [
              { name: '产品介绍', path: 'home/#product-intro' },
              { name: '五大中台', path: 'home/#five-platforms' },
              { name: '合作伙伴', path: 'home/#partners' },
            ],
            path: '/home'
          },
          {
            name: '产品中心', son: [
              { name: '点餐程序', path: 'product/#ordering' },
              { name: '店掌柜', path: 'product/#manager' },
              { name: '老板通', path: 'product/#boss' },
              { name: '火码云店', path: 'product/#cloud-store' },
              { name: '火码云屏', path: 'product/#cloud-screen' },
              { name: '火码电票助手', path: 'product/#helper' }
            ],
            path: '/product'
          },
          {
            name: '品牌运营', son: [
              { name: '服务范围', path: 'brand/#services' },
              { name: '案例展示', path: 'brand/#cases' },
            ],
            path: '/brand'
          },
          {
            name: '开发服务', son: [
              { name: '产品服务', path: 'development/#product-service' },
              { name: '定制开发', path: 'development/#custom' },
            ],
            path: '/development'
          },
          {
            name: '关于我们', son: [
              { name: '关于火码', path: 'about/#intro' },
              { name: '公司优势', path: 'about/#advantages' },
              { name: '荣誉证书', path: 'about/#certificates' }
            ],
            path: '/about'
          },
          {
            name: '合作洽谈', son: [
              { name: '联系我们', path: 'certificate/#security' },
              // { name: '权威证书', path: 'certificate/#certificates' },
            ],
            path: '/certificate'
          },
        ],
        icons: [
          { name: 'local', url: require('../../../img/home/local.png'), active: false, click: false, title: '地址 :', content: '上海市松江区小昆山镇中德路588号1幢4层火码科技' },
          { name: 'email', url: require('../../../img/home/email.png'), active: false, click: false, title: '邮箱 :', content: '16771538135@189.cn' },
          { name: 'phone', url: require('../../../img/home/phone.png'), active: false, click: false, title: '联系电话 :', content: '021-67728983' },
          { name: 'star', url: require('../../../img/home/star.png'), active: false, click: false, title: '关注我们', content: '' },
        ],
      }
    },
    computed: {
      // 获取当前激活的主菜单路径
      currentMainPath() {
        const path = this.$route.path.replace('/layout', '');
        // 如果是首页
        if (path === '' || path === '/') return '/';
        // 如果是其他页面，返回第一级路径
        return '/' + path.split('/')[1];
      },
      // 获取当前完整路径（包含hash）
      currentFullPath() {
        return this.$route.path.replace('/layout', '') + this.$route.hash;
      }
    },
  }
</script>
<style lang='less' scoped>
  .bottom-bar {
    width: 100%;
    height: 25.5vw;
    background-color: #111111;

    .bottom-main {
      height: 100%;
      color: #ffffff;
      margin: 0 auto;
      width: 100%;
      text-align: center;
      display: grid;
      grid-template-rows: 1fr 5vw;

      .main {
        display: flex;
        align-items: top;
        justify-content: center;
        padding-top: 3vw;

        .main-one {
          flex: 1;
          display: inline-block;
        }

        .main-two {
          width: 45vw;
          vertical-align: top;
          display: grid;
          grid-template-rows: 1.5vw 1fr;

          .main-two-top {
            display: grid;
            grid-template-columns: repeat(6, 1fr);

            font-family: MiSans, MiSans;
            font-weight: 600;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.9);
            line-height: 1.2vw;
            text-align: center;
            font-style: normal;

            .main-two-top-item {
              cursor: pointer;
              transition: color 0.3s;
              position: relative;

              &:hover {
                color: #E0422A;
              }

              &.active {
                color: #E0422A;

                &::after {
                  content: '';
                  position: absolute;
                  bottom: -5px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 2vw;
                  height: 2px;
                  background-color: #E0422A;
                }
              }
            }
          }

          .main-two-bottom {
            margin-top: 1vw;
            display: grid;
            grid-template-columns: repeat(6, 1fr);

            .main-two-bottom-item {
              height: 2vw;
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 16px;
              color: rgba(255, 255, 255, 0.7);
              line-height: 2vw;
              text-align: center;
              font-style: normal;

              div {
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                  color: #E0422A;
                }

                &.active {
                  color: #E0422A;
                }
              }
            }
          }
        }

        .main-three {
          flex: 1;

          .main-three-item {
            display: inline-block;
            margin: 0 .5vw;
            position: relative;

            img {
              width: 2vw;
              height: 2vw;
            }

            .qrcode {
              position: absolute;
              top: 0;
              left: 50%;
              z-index: 1000;
              transform: translateY(-115%) translateX(-50%);
              width: 160px;
              height: 200px;
              box-sizing: border-box;
              padding: 10px;
              background: #FFFFFF;
              box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);
              border-radius: 12px;

              &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-top: 11px solid #FFFFFF;
              }

              .title {
                height: 2vw;
                line-height: 2vw;
                font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: rgba(17, 17, 17, 0.6);
                text-align: center;
                font-style: normal;
              }
            }

            .active {
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateY(-120%) translateX(-50%);
              padding: 1vw;
              width: 304px;
              height: auto;
              background: #FFFFFF;
              box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);
              border-radius: 12px;


              &::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 11px solid transparent;
                border-right: 11px solid transparent;
                border-top: 11px solid #FFFFFF;
              }

              .title {
                height: 26px;
                font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: rgba(17, 17, 17, 0.6);
                line-height: 26px;
                text-align: justify;
                font-style: normal;
              }

              .content {
                margin-top: .3vw;
                width: 255px;
                height: 52px;
                font-family: MiSans, MiSans;
                font-weight: 600;
                font-size: 16px;
                color: #111111;
                line-height: 26px;
                text-align: justify;
                font-style: normal;
              }
            }
          }
        }
      }


      .footer {
        height: 3vw;
        justify-content: center;
        align-items: center;
        position: relative;

        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        line-height: 3vw;
        color: rgba(255, 255, 255, 0.7);
        font-style: normal;

        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 0%;
          left: 50%;
          transform: translateX(-50%);
          width: 80%;
          height: 1px;
          background-color: rgba(255, 255, 255, .18);
        }
      }
    }
  }

  @media screen and (max-width: 1669px) {
    .bottom-bar {
      .bottom-main {
        .main {
          padding: 3vw 4vw 0;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .bottom-bar {
      .bottom-main {
        .main {
          padding-top: 3vw;

          .main-two {
            .main-two-top {
              font-size: 14px;
              line-height: 1.5vw;

              .main-two-top-item {
                &.active::after {
                  width: 2.5vw;
                }
              }
            }

            .main-two-bottom {
              .main-two-bottom-item {
                font-size: 14px;
                line-height: 2.2vw;
              }
            }
          }

          .main-three {
            .main-three-item {
              .active {
                width: 260px;
                padding: 0.8vw;

                .title {
                  font-size: 14px;
                  height: 22px;
                  line-height: 22px;
                }

                .content {
                  font-size: 14px;
                  line-height: 22px;
                  width: 220px;
                  height: 44px;
                }
              }
            }
          }
        }

        .footer {
          font-size: 14px;
        }
      }
    }
  }

  @media screen and (max-width: 1240px) {
    .bottom-bar {
      .bottom-main {
        .main {
          padding: 2vw 4vw 0;

          .main-two {
            .main-two-top {
              font-size: 13px;
            }

            .main-two-bottom {
              .main-two-bottom-item {
                font-size: 13px;
              }
            }
          }

          .main-three {
            .main-three-item {
              .active {
                width: 240px;

                .title,
                .content {
                  font-size: 13px;
                }
              }
            }
          }
        }

        .footer {
          font-size: 13px;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .bottom-bar {
      .bottom-main {
        .main {
          padding: 2vw 4vw 0;

          .main-two {
            .main-two-top {
              font-size: 12px;
            }

            .main-two-bottom {
              .main-two-bottom-item {
                font-size: 12px;
              }
            }
          }
        }

        .footer {
          font-size: 10px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .bottom-bar {
      .bottom-main {
        .main {
          padding: 2vw 4vw 0;

          .main-two {
            .main-two-top {
              font-size: 12px;
            }

            .main-two-bottom {
              .main-two-bottom-item {
                font-size: 12px;
              }
            }
          }
        }

        .footer {
          font-size: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/BottomBar/BottomBar.vue